"use client";
import { contactInfo } from "@/lib/contacts";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";
import React from "react";
import ContactForm from "../InquryForm/ContactForm";

export default function ConcatPage({ locale }: { locale: string }) {
	const t = useTranslations();
	const navigation = {
		contact: [
			{ name: `Tel: ${contactInfo.phone}`, href: `tel:${contactInfo.phone}`, icon: "ri-smartphone-line" },
			{ name: `Email: ${contactInfo.email}`, href: `mailto:${contactInfo.email}`, icon: "ri-mail-line" },
			{
				name: `Whatsapp: ${contactInfo.whatsapp}`,
				href: `https://wa.me/${contactInfo.whatsapp}`,
				icon: "ri-whatsapp-fill",
			},
			{
				name: contactInfo.address,
				href: "https://www.google.com/maps/search/No.+409+Guanbang+International,+Linhe+Road,+Huadu+District,+Guangzhou/@23.4305685,113.0510603,11z/data=!3m1!4b1?hl=en&entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D",
				icon: "ri-map-pin-2-line",
			},
		],
	};
	return (
		<div className="bg-[#F2F4F5] pb-10 md:pb-20">
			<HomeTaile msg={t("common.Contact_Us")} />
			<div className="mx-auto grid max-w-7xl grid-cols-1 items-center bg-white lg:grid-cols-2">
				<div className="p-6">
					<h2 className="text-[40px] text-[#D8D8D8]">{t("contact.CONTACT US")}</h2>
					<h3 className="text-[28px] font-black text-black">{t("contact.Stary Line")}</h3>
					{/* <p className="text-gray-600 text-sm font-light mt-4">{t("contact.oumeilai1")}</p> */}
					<div className="mt-10 md:mt-0">
						<ul role="list" className="mt-6 space-y-4">
							{navigation.contact.map((item, index) => (
								<li key={index}>
									<Link
										href={item.href}
										target="_blank"
										className="text-sm leading-6 text-gray-700 hover:text-main"
									>
										<i className={`${item.icon} ri-xl`}></i>
										<span
											style={{
												overflowWrap: "break-word",
											}}
										>
											{" "}
											{item.name}
										</span>
									</Link>
								</li>
							))}
						</ul>
					</div>
				</div>
				<div>
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24432.819661569592!2d-83.0512124!3d40.0508144!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388da45363cd03%3A0x4a03cbdf57f853bc!2sLuxe%20Ave%2C%20Columbus%2C%20OH%2043220!5e0!3m2!1sen!2sus!4v1736754225890!5m2!1sen!2sus"
						width="100%"
						height="450"
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
					></iframe>
				</div>
			</div>
			<div className="">
				<div className="fixbg mt-20 bg-[url(/image/contact-bj.jpg)] bg-cover bg-fixed bg-no-repeat">
					<div className="container py-20">
						<h2 className="mb-4 text-center text-[28px] font-black text-white">{t("contact.CONTACT US")}</h2>
						<p className="mb-14 text-center text-white">{t("contact.cccc1111")}</p>
						<div className="grid grid-cols-1 gap-12 md:grid-cols-3 "></div>
					</div>
				</div>
			</div>

			<ContactForm
				locale={locale}
				title={t("base.getInstantQuoteAndTS")}
				// @ts-ignore
				titleContent={t("form.fillOutIn")}
				className="!py-0 "
				innerClassName="!shadow-none !rounded-none"
			></ContactForm>
		</div>
	);
}
export function HomeTaile({ msg }) {
	return (
		<div className="mb-[40px] bg-[url(/image/gb.png)]   bg-[length:100%_100%] bg-no-repeat  py-[80px]">
			<div className="container max-md:mt-5">
				<h2 className="text-bloak text-center text-[42px] font-medium  text-white max-md:text-2xl ">{msg}</h2>
			</div>
		</div>
	);
}
